export const es = {
  // Common
  common: {
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    search: 'Buscar',
    clear: 'Limpiar',
    all: 'Todos',
    available: 'Disponibles',
    sold: 'Vendidos',
    reserved: 'Reservados',
    occupied: 'Ocupados',
    total: 'Total',
    value: 'Valor',
    price: 'Precio',
    date: 'Fecha',
    lottery: 'Lotería',
    organizer: 'Organizador',
    processing: 'Procesando...',
    ticketsSingular: 'boleto',
    ticketsPlural: 'boletos',
    selectedSingular: 'seleccionado',
    selectedPlural: 'seleccionados'
  },

  // Raffle Page
  raffle: {
    loadingRaffle: 'Cargando rifa...',
    raffleNotFound: 'Rifa no encontrada',
    verifyLink: 'Verifica que el link sea correcto',
    errorLoading: 'Error al cargar la rifa',
    raffleNumber: 'Rifa #',
    drawDate: 'Fecha Sorteo',
    noNumber: 'Sin número',
    showingSample: 'Mostrando una muestra de boletos. Usa el buscador para encontrar números específicos.',
    showingSampleDesktop: 'Mostrando una muestra aleatoria de boletos. Usa el buscador para encontrar números específicos.'
  },

  // Ticket actions
  tickets: {
    searchTicket: 'Buscar número...',
    searchPlaceholder: 'Buscar número (ej: 42, 15, 73)',
    searchMultiple: 'Puedes buscar múltiples números separándolos con comas',
    multipleSelection: 'Selección Múltiple',
    multipleSelectionActive: '✓ Selección Múltiple',
    multipleSelectionActiveDesktop: '✓ Selección Múltiple Activa',
    activateMultipleSelection: 'Activar Selección Múltiple',
    randomNumbers: 'números',
    randomSelection: 'A su suerte',
    reserveAll: 'Reservar Todos',
    reserveSelected: 'Reservar Seleccionados',
    clearSelection: 'Limpiar',
    ticketOccupied: 'Este boleto ya está ocupado',
    noAvailableTickets: 'No hay boletos disponibles',
    onlyAvailable: 'Solo hay {count} boletos disponibles',
    randomTicketsAdded: '{count} números aleatorios agregados',
    noTicketsSelected: 'No has seleccionado ningún boleto',
    ticketsSelected: '{count} boletos seleccionados',
    noResults: 'No se encontraron boletos',
    noResultsFor: 'No se encontraron resultados para "{search}"',
    clearSearch: 'Limpiar búsqueda'
  },

  // Private Mode
  privateMode: {
    title: 'Modo Privado',
    description: 'Esta rifa está en modo privado. Busca tu número para verificar disponibilidad.',
    searchButton: 'Buscar mi número',
    searchNumbers: 'Buscar Números'
  },

  // Ticket Modal
  modal: {
    reserveTicket: 'Reservar Boleto',
    reserveTickets: 'Reservar {count} Boletos',
    personalInfo: 'Información Personal',
    fullName: 'Nombre completo',
    phone: 'Teléfono',
    email: 'Email',
    address: 'Dirección',
    specialNote: 'Enviar anotación especial',
    writeNote: 'Escribe tu anotación aquí...',
    confirmNote: 'Al confirmar, el dueño de la rifa se contactará con usted.',
    requiredFields: 'Por favor completa los campos obligatorios',
    ticketReserved: '¡Boleto {number} reservado exitosamente!',
    ticketsReserved: '¡{count} boletos reservados exitosamente!',
    errorReserving: 'Error al reservar el boleto. Por favor intenta nuevamente.',
    errorReservingMultiple: 'Error al reservar los boletos. Por favor intenta nuevamente.',
    selectedNumbers: 'Números seleccionados:',
    totalValue: 'Valor total'
  },

  // Placeholders
  placeholders: {
    name: 'Juan Pérez',
    phone: '300 123 4567',
    email: 'correo@ejemplo.com',
    address: 'Calle 123 #45-67'
  },

  // Stats
  stats: {
    available: 'Disponibles',
    reserved: 'Reservados',
    sold: 'Vendidos',
    occupied: 'Ocupados'
  },

  // Auth Pages
  auth: {
    login: {
      title: 'Iniciar sesión',
      or: 'O',
      createAccount: 'crea una nueva cuenta',
      email: 'Correo electrónico',
      password: 'Contraseña',
      forgotPassword: '¿Olvidaste tu contraseña?',
      loggingIn: 'Iniciando sesión...',
      loginButton: 'Iniciar sesión'
    },
    register: {
      title: 'Crear cuenta',
      titleNew: 'Crear nueva cuenta',
      or: 'O',
      haveAccount: 'ya tienes una cuenta',
      loginIfHaveAccount: 'inicia sesión si ya tienes una cuenta',
      fullName: 'Nombre completo',
      email: 'Correo electrónico',
      password: 'Contraseña',
      confirmPassword: 'Confirmar contraseña',
      registering: 'Creando cuenta...',
      registerButton: 'Crear cuenta',
      passwordMismatch: 'Las contraseñas no coinciden',
      accountType: 'Tipo de cuenta',
      userAccount: 'Usuario (Organizador de rifas)',
      vendorAccount: 'Vendedor',
      nameRequired: 'El nombre es requerido',
      emailRequired: 'El correo electrónico es requerido',
      emailInvalid: 'Correo electrónico inválido',
      passwordRequired: 'La contraseña es requerida',
      passwordMinLength: 'La contraseña debe tener al menos 6 caracteres',
      passwordPlaceholder: 'Mínimo 6 caracteres',
      repeatPassword: 'Repite la contraseña'
    },
    forgotPassword: {
      title: 'Recuperar contraseña',
      description: 'Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
      email: 'Correo electrónico',
      sending: 'Enviando...',
      sendButton: 'Enviar enlace',
      backToLogin: 'Volver a iniciar sesión',
      success: 'Se ha enviado un enlace a tu correo electrónico',
      error: 'Error al enviar el enlace. Por favor intenta nuevamente.'
    }
  },

  // Error Pages
  errorPages: {
    notFound: {
      title: '404',
      subtitle: 'Página no encontrada',
      description: 'Lo sentimos, no pudimos encontrar la página que buscas.',
      backHome: 'Volver al inicio'
    },
    unauthorized: {
      title: '401',
      subtitle: 'No autorizado',
      description: 'No tienes permisos para acceder a esta página.',
      login: 'Iniciar sesión'
    }
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Bienvenido',
    myRaffles: 'Mis Rifas',
    createRaffle: 'Crear Rifa',
    logout: 'Cerrar sesión'
  }
};